import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * The gift certificate hive sells for someone else. Handing an owned seat to a contact is a
 * licence action and lives with the rest of them in `~/stores/person/licenses`; buying a license
 * is checkout's job — every purchase and upgrade surface leaves for it via `useLicensePurchase`.
 */
export const useLicenseGiftingStore = defineStore('license-gifting', () => {
    // The purchased certificate, carried from the purchase modal to the confirmation modal that
    // shows the buyer the code they now have to pass on.
    const giftCertCode = ref('');
    const giftCertAmount = ref(0);
    const giftCertEmail = ref('');
    const giftCertName = ref('');

    function setGiftCertificateDetails(code: string, email: string, name: string, amount: number) {
        giftCertCode.value = code;
        giftCertEmail.value = email;
        giftCertAmount.value = amount;
        giftCertName.value = name;
    }

    return {
        giftCertCode,
        giftCertAmount,
        giftCertEmail,
        giftCertName,
        setGiftCertificateDetails,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useLicenseGiftingStore, import.meta.hot))
}
